import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon.jsx';

const { FiHeart, FiLock } = FiIcons;

const Footer = () => {
  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#2c3a50] text-white py-16 border-t border-[#c5a059]/10">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <div className="flex items-center justify-center gap-3 mb-10">
          <div className="text-3xl select-none">🌱</div>
          <div className="flex flex-col text-left">
            <span className="font-black text-lg leading-none">SEMENTINHA</span>
            <span className="text-[#c5a059] font-bold text-[9px] tracking-[0.1em] uppercase">Desenvolvimento Emocional Saudável</span>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-x-12 gap-y-4 mb-12 text-sm font-bold uppercase tracking-widest text-gray-400">
          <button onClick={() => scrollTo('benefits')} className="hover:text-[#c5a059] transition-colors">Benefícios</button>
          <button onClick={() => scrollTo('about')} className="hover:text-[#c5a059] transition-colors">Sobre</button>
          <button onClick={() => scrollTo('testimonials')} className="hover:text-[#c5a059] transition-colors">Depoimentos</button>
          <button onClick={() => scrollTo('curriculum')} className="hover:text-[#c5a059] transition-colors">Conteúdo</button>
        </div>

        <div className="max-w-2xl mx-auto space-y-4 pt-8 border-t border-white/5">
          <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest">
            Sementinha – Os primeiros passos para um desenvolvimento emocional saudável
          </p>
          <div className="flex items-center justify-center gap-2 text-[#c5a059]">
            <SafeIcon icon={FiLock} />
            <span className="text-xs font-bold uppercase tracking-tighter">Ambiente 100% Seguro e Conteúdo Protegido</span>
          </div>
          <p className="text-xs text-gray-500 font-medium leading-relaxed">
            © 2026 SEMENTINHA por Simone Miranda Felipe. Todos os direitos reservados.
          </p>
          <p className="text-xs flex items-center justify-center text-gray-400">
            Feito com <SafeIcon icon={FiHeart} className="mx-1 text-red-500" /> para transformar famílias.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;